export const FONT_CONFIG = {
  text: "mmmmmmmmmm", // 测试文本 - 使用 m 字符，宽度差异明显
  size: "16px",       // 测试字体大小 - 标准大小
  fallbackFont: "monospace" // 回退字体 - 等宽字体，宽度稳定
};

// 常用字体列表
export const COMMON_FONTS = [

  // 英文字体
  "Arial",
  "Times New Roman",
  "Courier New",
  "Helvetica",
  "Georgia",
  "Verdana",
  "Tahoma",
  "Trebuchet MS",
  "Comic Sans MS",
  "Impact",
  "Arial Black",

  // 中文字体
  "Microsoft YaHei",
  "SimSun",
  "SimHei",
  "KaiTi",
  "FangSong",
  "STSong",
  "STHeiti",
  "STKaiti",

  // 现代字体
  "Roboto",
  "Noto Sans",
  "Open Sans",
  "Lato",
  "Source Sans Pro",
  "PT Sans",
  "Ubuntu"
];

export const FONT_CONFIG_FIXED = "14px Arial, sans-serif";
